import { BLOCK_CLASSES as t } from "../../constants.js";
import { stylable as l } from "../decorators/stylable.js";
const r = l({
  inline: !1,
  content: "(block | list)*",
  group: "block",
  selectable: !1,
  attrs: {
    type: { default: "callout" }
  },
  parseDOM: [{ tag: `.${t.callout}` }],
  toDOM(e) {
    return [
      "div",
      {
        class: `${t.callout}`,
        "data-insertable": "true"
      },
      0
    ];
  }
});
export {
  r as calloutSpec
};
